<template>
    <router-link :to="{ name: 'UserForm', params: { id: local_userform.id } }">
        <div
            v-if="local_userform"
            class="userformPreviewCard"
            :class="{'inset': inset}"
        >
            <v-layout
                row
                wrap
            >
                <div
                    v-if="!inset"
                    style="background:rgba(0,0,0,0.05);border-radius:25px;padding:4px;margin: 10px;aspect-ratio: 1/1;width:32.5px;height:32.5px;"
                >
                    <v-icon>
                        mdi-list-box-outline
                    </v-icon>
                </div>
                <div>
                    <b>{{ local_userform.name }}</b>
                    <span v-if="local_userform.form_number || local_userform.party_name">
                        <br/>
                        <span
                            v-if="local_userform.form_number"
                        >
                            {{ local_userform.form_number }}
                        </span>
                        <span
                            v-if="local_userform.form_number && local_userform.party_name"
                        >
                            &nbsp;|&nbsp;
                        </span>
                        <span
                            v-if="local_userform.party_name"
                        >
                            {{ local_userform.party_name }}
                        </span>
                    </span>
                    <br/>
                    <span>
                        <b>{{ local_userform.case.case_type.name }}</b> - {{ local_userform.case.case_number }}
                    </span>
                </div>
            </v-layout>
        </div>
    </router-link>
</template>

<script>
import api from '@/api'

export default {
    name: 'UserFormPreview',
    props: ['userform', 'id', 'inset'],
    data () {
        return {
            local_userform: null,
            searching: false
        }
    },
    created () {
        if (this.userform) {
            this.local_userform = JSON.parse(JSON.stringify(this.userform))
        } else {
            if (this.id)
                this.fetch()
        }
    },
    methods: {
        fetch () {
            this.searching = true
            api.userform.userForm.get(this.id)
                .then(data => {
                    this.searching = true
                    this.local_userform = data
                })
        }
    }
}
</script>

<style scoped>
.userformPreviewCard {
    background: rgba(0,0,0,0.05);
    padding: 5px;
    border-radius:5px;
    cursor:pointer;
}

.userformPreviewCard:hover {
    background: rgba(0,0,0,0.1);
}

.inset {
    background: unset;
    padding: unset !important;
}

.small-title {
    font-size: 12px !important;
    font-weight: 900 !important;
}

a {
    text-decoration: none;
    color: black;
}
</style>